import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

// Create a single MSAL instance to be used throughout the app
export const msalInstance = new PublicClientApplication(msalConfig);